/*
 * 虎扑 - 步行街热帖（服务端路由）
 */
export async function fetchHupuHot() {
  const res = await fetch('/server-api/hupu')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
